import { render, staticRenderFns } from "./TenantsWidget.vue?vue&type=template&id=0c4e332f&scoped=true"
import script from "./TenantsWidget.vue?vue&type=script&lang=js"
export * from "./TenantsWidget.vue?vue&type=script&lang=js"
import style0 from "./TenantsWidget.vue?vue&type=style&index=0&id=0c4e332f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e332f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4e332f')) {
      api.createRecord('0c4e332f', component.options)
    } else {
      api.reload('0c4e332f', component.options)
    }
    module.hot.accept("./TenantsWidget.vue?vue&type=template&id=0c4e332f&scoped=true", function () {
      api.rerender('0c4e332f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/TenantsWidget.vue"
export default component.exports